import React, { useEffect } from "react";
import ProductSpecifications from "../components/shop/ProductSpecifications";
import BandIcons from "../components/shop/BandIcons";
import WhatMatters from "../components/shop/WhatMatters";
import Layers from "../components/shop/Layers";
import ReviewSection from "../components/shop/ReviewSection";

export default function ShopPage() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div className="">
      <div>
        <ProductSpecifications />
        <BandIcons />
        <WhatMatters />
        <Layers />
        <ReviewSection />
      </div>
    </div>
  );
}
